


























import { IDialog } from "@/lib/interfaces/dialog.interface";
import { Component } from "vue-property-decorator";
import CompanySideCard from "../company/CompanySideCard.vue";
import InvoicePartyForm from "../invoice/InvoicePartyForm.vue";
import PersonSideCard from "../person/PersonSideCard.vue";
import RefsCompanyAddress from "../utility/RefsCompanyAddress.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import RefsSelectForm from "../utility/RefsSelectForm.vue";

@Component({
  components: {
    RefsSelectForm,
    RefsSelect,
    RefsCompanyAddress,
    PersonSideCard,
    CompanySideCard
  },
  filters: {}
})
export default class RepairEstimatePartyForm extends InvoicePartyForm implements IDialog {}
